import {notification} from "antd";

import i18next from "i18next";

export const showError = (text, duration, message, status, additionalText) => {
  notification[status || "error"]({
    message: message || i18next.t("ERROR_COMMON_ERROR_TITLE"),
    duration: duration || 4.5,
    description:
      `${i18next.t(text)} ${additionalText ?? ""}` ||
      i18next.t("ERROR_COMMON_ERROR_MESSAGE"),
  });
};

export const showWarning = (text, duration, message, status) => {
  notification[status || "warning"]({
    message: message || i18next.t("ERROR_COMMON_WARNING_TITLE"),
    duration: duration || 4.5,
    description: i18next.t(text) || i18next.t("ERROR_COMMON_WARNING_MESSAGE"),
  });
};

export const showSuccess = (text, duration, message, status) => {
  notification[status || "success"]({
    message: message || i18next.t("ERROR_COMMON_SUCCESS_TITLE"),
    duration: duration || 4,
    description: text || i18next.t("ERROR_COMMON_SUCCESS_MESSAGE"),
  });
};

export const showInfo = (text, duration, message, status) => {
  notification[status || "info"]({
    message: message || i18next.t("ERROR_COMMON_INFO_TITLE"),
    duration: duration || 4,
    description: text || i18next.t("ERROR_COMMON_INFO_MESSAGE"),
  });
};
